import { orchestrator } from 'satcheljs';
import {
    prepareEvent,
    setEventBodyFromViewState,
    setRoomBookingAssistantEnabled,
} from 'owa-calendar-compose-form-actions';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import shouldSupportAutoRoomBooking from 'owa-calendar-compose-form-store/lib/selectors/shouldSupportAutoRoomBooking';
import resolveStringLocation from '../utils/resolveStringLocation';

export default orchestrator(prepareEvent, actionMessage => {
    setEventBodyFromViewState();

    // if the event recurrence or selected calendar changed, room should not be booked automatically
    // user might have enabled auto room booking first and then changing the recurrence or calendar, disable it when saving event
    if (!shouldSupportAutoRoomBooking()) {
        setRoomBookingAssistantEnabled(false);
    }

    let uiState = getComposeStore().uiState;

    // if locationWell is not coming from compose form, ignore action
    if (!uiState) {
        return;
    }

    let stringLocation = uiState.unresolvedLocation;

    // If there is unresolved text in the location well, resolve it into a location persona
    resolveStringLocation(stringLocation);
});
